import { render, staticRenderFns } from "./CommunicationsPending.vue?vue&type=template&id=5d62d294"
import script from "./CommunicationsPending.vue?vue&type=script&lang=js"
export * from "./CommunicationsPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports